module.exports = __webpack_public_path__ + "img/icon_back.233cacb0.svg";